// extracted by mini-css-extract-plugin
module.exports = {"FetchSelectContainer":"FetchSelect_FetchSelectContainer__rs-79"};